import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { PermissionEnum } from '@model';
import { SiteResolver } from '@resolver';
import { BMDModule, HomeComponent, SiteComponent } from '@view';
import { AuthGuard } from '../guard';

enum Routing {
  doc = 'doc',
  list = 'list',
  root = '',
  viewSite = 'details/:siteId/view-site',
}

const routerOptions: ExtraOptions = {
  enableTracing: false,
  onSameUrlNavigation: 'reload',
};

const routes: Routes = [
  {
    canActivate: [AuthGuard],
    component: SiteComponent,
    data: { requiredPermissions: [PermissionEnum.update] },
    path: Routing.viewSite,
    resolve: { data: SiteResolver },
  },
  {
    canActivate: [AuthGuard],
    component: HomeComponent,
    data: { requiredPermissions: [PermissionEnum.read] },
    path: Routing.root,
    pathMatch: 'full',
  },
  {
    path: Routing.doc,
    redirectTo: '/doc/index.html',
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [BMDModule, RouterModule.forRoot(routes, routerOptions)],
  providers: [AuthGuard, SiteResolver],
})
export class CoreRoutingModule {}
